<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ANSo22/tc-custom/9781250015020.jpg?1724411687677" alt="This image is the cover for the book When in Doubt, Add Butter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When in Doubt, Add Butter
      </h1>
      <p class="bookDescription body article font2">
        <b>A delicious novel about a private chef’s search for all the right ingredients to true love, by the <i>New York Times</i>–bestselling author of <i>The Cookbook Club</i>.</b><br/><br/>As far as Gemma is concerned, her days of dating are over. In fact, it’s her job to cater other peoples’ dates, and that’s just fine by her. At thirty-seven, she has her own business, working as a private chef, and her life feels full and secure. She’s got six steady clients that keep her hands full.<br/><br/>There’s Lex, the fussy but fabulous department store owner who loves Oysters Rockefeller and 1950s comfort food; Willa, who needs to lose weight under doctor’s orders but still believes butter makes everything better; a colorful family who may or may not be part of the Russian mob; an überwealthy Georgetown family; the picture-perfect Van Houghtens, whose matriarch is “allergic to everything”; and finally, a man she calls “Mr. Tuesday,” whom she has never met but who she is strangely drawn to.<br/><br/>For Gemma, cooking is predictable. Recipes are certain. Use good ingredients, follow the directions, and you are assured success. Life, on the other hand, is full of variables. So when Gemma’s life takes an unexpected turn on a road she always thought was straight and narrow, she must face her past and move on in ways she never would have imagined. Because sometimes in life, all you need is a little hope, a lot of courage, and—oh yes—butter.<br/><br/><b>Praise for <i>When In Doubt, Add Butter</i></b><br/><br/>“Harbison dazzles in her latest, a perfect blend of chick lit and women’s fiction. . . . Absolutely first-rate.” —<i>Publishers Weekly</i> (starred review)<br/><br/>“A loveable heroine and an engaging cast of eccentrics make for a cheerful summer read.” —<i>Kirkus Reviews</i><br/><br/>“Delicious, just like dessert.” —<i>People</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth Harbison
      </h2>
      
      <p class="authorDescription body article"><P>BETH HARBISON is <I>The New York Times </I>bestselling author of <I>Always Something There To Remind Me; Thin, Rich, Pretty; Hope In A Jar; Secrets of a Shoe Addict </I>and <I>Shoe Addicts Anonymous</I>. She grew up in Potomac, Maryland, outside Washington, D.C., and now shares her time between that suburb, New York City and a quiet home on the eastern shore.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62a0e339